import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import mobilePreview from './mobilePreview';
import configure from './configure';
import { premiumModel, pageModal, buttonModal } from './mobilePreview/components';
import draggable from 'vuedraggable';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { getControlsResources } from '@/views/template/controlManage/request';
import { INITAL, NAVUGATIOBN, STYLE, CONFIGURENAME, TITLETOPCOFIGURE } from './utils';
import { dynamicControlDetail, dynamicControlSetConfig } from './../request';
export default {
  //注册draggable组件
  components: {
    draggable,
    topTitle,
    mobilePreview,
    configure,
    premiumModel,
    pageModal,
    buttonModal
  },
  data() {
    return {
      TITLETOPCOFIGURE,
      arr2: [],
      grpupA: {
        name: 'site',
        pull: 'clone',
        put: false
      },
      navList: [],
      INITAL,
      NAVUGATIOBN,
      navIndex: -1,
      itemIndex: -1,
      configureObj: {},
      configureList: [],
      timer1: '',
      themeColor: '',
      premiumShow: false,
      isDisplayNavigation: false,
      CONFIGURENAME,
      name: '',
      backgroundImage: undefined,
      changeType: false,
      pageDescription: false,
      pageDescriptionConfig: {},
      pagePopUp: false,
      pagePopUpConfig: {},
      pageModalShow: false,
      buttonModalShow: false,
      buttonPopUpConfig: {},
      buttonModalIndex: -1,
      pageTypeName: undefined
    };
  },
  created() {
    // 判断sessionStorage中是否有oldFrom
    if (sessionStorage.getItem('oldForm')) {
      sessionStorage.removeItem('oldForm');
    }
    this.getInfoFun();
  },
  methods: {
    onClickPremium(index) {
      if (index === 0) {
        this.onOpenButtonModal(index, '');
      } else {
        this.premiumShow = false;
      }
    },
    // 打开按钮弹窗
    onOpenButtonModal(index, key, isPremium) {
      var _this$arr2$this$itemI;
      this.buttonModalIndex = index;
      let item = (_this$arr2$this$itemI = this.arr2[this.itemIndex].style) === null || _this$arr2$this$itemI === void 0 ? void 0 : _this$arr2$this$itemI.buttonInfo[index];
      if (item.buttonPopUp) {
        this.buttonPopUpConfig = item.buttonPopUpConfig;
        if (key != 'change') {
          this.buttonModalShow = true;
        }
      } else {
        this.buttonModalIndex = -1;
        this.buttonPopUpConfig = {};
      }
    },
    // 进入页面获取配置数据详情
    async getInfoFun() {
      console.log(this.$route.params.type, '------------进入页面获取配置数据详情--------');
      const res = await dynamicControlDetail({
        id: this.$route.params.id
      });
      this.name = res.name;
      if (!res.controlsGroupConfig) {
        this.arr2 = recursionCopy(INITAL[this.$route.params.type]);
        // 首次配置的时候不会走接口所以pageTypeName需要从结构默认数据里赋值
        this.pageTypeName = this.arr2[0].style.pageTitle;
      } else {
        const infoObj = recursionCopy(JSON.parse(res.controlsGroupConfig));
        this.pageTypeName = res.pageTypeName;
        console.log(infoObj, this.pageTypeName, '------------infoObj--------');
        // 配置区域赋值
        let arr = recursionCopy([this.INITAL[this.$route.params.type][0]]);
        console.log(arr, '------------arr  arr--------');
        arr[0].style = {
          isDisplayNavigation: infoObj.isDisplayNavigation,
          titleColor: infoObj.titleColor,
          backgroundColor: infoObj.backgroundColor,
          backgroundImage: infoObj.backgroundImage,
          themeColor: infoObj.themeColor,
          pageDescription: infoObj.pageDescription || false,
          pageDescriptionConfig: infoObj.pageDescriptionConfig || TITLETOPCOFIGURE.pageDescriptionConfig,
          pagePopUp: infoObj.pagePopUp || false,
          pagePopUpConfig: infoObj.pagePopUpConfig || TITLETOPCOFIGURE.pagePopUpConfig,
          pageTitle: this.$route.params.type != 'DETAILS' ? infoObj.pageTitle || this.pageTypeName : undefined
        };
        this.pageContentAssignment(infoObj);
        infoObj.controlsConfig.map(item => {
          let obj = {
            controlsId: item.controlsId,
            controlsMark: item.controlsMark,
            isClick: false,
            style: item.controlsObject
          };
          console.log(obj, '----------默认数据--------');
          if (obj.controlsMark === 'policyDetail') {
            // 保单详情增加非可退保文案
            if (obj.style.policyCancelConfig) {
              obj.style.policyCancelConfig.policyStatus = obj.style.policyCancelConfig.policyStatus || [1];
              obj.style.policyCancelConfig.uncancelableTips = obj.style.policyCancelConfig.uncancelableTips || '请联系专属服务团队办理退保业务。';
            } else {
              obj.style.policyCancelConfig = {
                policyStatus: [1],
                uncancelableTips: '请联系专属服务团队办理退保业务。'
              };
            }
          } else if (obj.controlsMark === 'queryInfo') {
            // 查询记录页增加配置：保单卡片按钮、开具发票配置
            let newBtns = [{
              buttonName: '开具发票',
              buttonFontColor: '#fff',
              buttonBgColor: '#FF6B00',
              buttonDisplayStatus: [1, 2, 3, 6],
              //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败 发票状态：未开票、开票失败；是否可开具发票：可开具发票；
              buttonInvoiceStatus: [],
              //发票按钮可展示状态：未开票 '', 未开票 'UNINVOICED', 开票失败'INVOICED_FAILED', 开票成功'SUCCESS'
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {}
            }, {
              buttonName: '查看发票',
              buttonFontColor: '#FF6B00',
              buttonBgColor: '#fff',
              buttonDisplayStatus: [1, 2, 3, 6],
              //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败 发票状态：已开票；
              buttonInvoiceStatus: [],
              //发票按钮可展示状态：未开票 'UNINVOICED', 开票失败'INVOICED_FAILED', 开票成功'SUCCESS'
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {}
            }];
            if (obj.style.policySearch) {
              if (!obj.style.policySearch.buttonInfo.buttons.find(item => item.buttonName == '开具发票')) {
                obj.style.policySearch.buttonInfo.buttons.push(newBtns[0]);
              }
              if (!obj.style.policySearch.buttonInfo.buttons.find(item => item.buttonName == '查看发票')) {
                obj.style.policySearch.buttonInfo.buttons.push(newBtns[1]);
              }
              if (!obj.style.policySearch.invoiceInfo) {
                obj.style.policySearch.invoiceInfo = {
                  buttonDisplay: false,
                  buttons: [{
                    buttonName: '开具发票',
                    buttonFontColor: '#fff',
                    buttonBgColor: '#FF6B00',
                    mark: 1,
                    buttonPopUp: false,
                    buttonPopUpConfig: {},
                    idVerity: true //身份验证
                  }]
                };
              }
            }
          }
          arr.push(obj);
        });
        this.arr2 = arr;
      }
      this.arr2[0].isClick = true;
      this.configureObj = this.arr2[0];
      this.itemIndex = 0;
      this.themeColor = this.arr2[0].style.themeColor;
      this.isDisplayNavigation = this.arr2[0].style.isDisplayNavigation;
      this.navList = await getControlsResources({
        pageType: this.$route.params.type
      });
      this.arr2.map(item => {
        if (item.controlsMark == 'product' || item.controlsMark == 'information') {
          item.style.clauseColor = this.themeColor;
        }
      });
      if (this.$route.params.type == 'DETAILS') {
        this.arr2.map(item => {
          if ((item.controlsMark == 'navigation' || item.controlsMark == 'mainDrawing') && !item.style.controlsComponentsId) {
            const arr = this.navList.filter(item2 => item2.mark == item.controlsMark);
            console.log(arr[0]);
            item.style.controlsComponentsId = arr[0].childer[0].id;
            item.style.controlsComponentsMark = arr[0].childer[0].mark;
            item.controlsId = String(arr[0].id);
          }
        });
      }
    },
    // 页面说明赋值
    pageContentAssignment(obj, showPage) {
      // 页面说明
      this.pageDescription = obj.pageDescription || false;
      this.pageDescriptionConfig = obj.pageDescriptionConfig || recursionCopy(TITLETOPCOFIGURE.pageDescriptionConfig);
      this.pagePopUp = obj.pagePopUp || false;
      console.log(obj.backgroundImage, encodeURI(obj.backgroundImage), '--------页面说明赋值 obj.backgroundImage--------');
      this.backgroundImage = obj.backgroundImage ? encodeURI(obj.backgroundImage) : undefined;
      // 页面弹窗
      this.pagePopUpConfig = obj.pagePopUpConfig || recursionCopy(TITLETOPCOFIGURE.pagePopUpConfig);
      if (this.pagePopUp && showPage) {
        this.pageModalShow = true;
      } else {
        this.pageModalShow = false;
      }
    },
    //拖拽完成事件
    add2(e) {
      this.arr2.map(item => {
        item.isClick = false;
      });
      let obj = recursionCopy(this.arr2[e.newIndex]);
      if (STYLE[obj.controlsMark]) {
        let style = recursionCopy(STYLE[obj.controlsMark]);
        style.controlsComponentsMark = obj.mark;
        style.controlsComponentsId = obj.id;
        obj.style = style;
        if (obj.controlsMark == 'bottomButton') {
          let buttonColor = this.themeColor;
          if (obj.controlsComponentsMark != 'bottomButton2') {
            buttonColor = '#fff';
          }
          obj.style.buttonInfo[0].buttonBgColor = this.themeColor;
          obj.style.buttonColor = buttonColor;
        } else if (obj.controlsMark == 'product' || obj.controlsMark == 'information') {
          obj.style.clauseColor = this.themeColor;
        } else if (obj.controlsMark == 'trial') {
          obj.style.color = this.themeColor;
        } else if (obj.controlsMark == 'navigation') {
          obj.style.fontColor = this.themeColor;
        }
      }
      obj.isClick = true;
      this.arr2.splice(e.newIndex, 1, obj);
      this.itemFun(this.arr2[e.newIndex], e.newIndex);
    },
    onMove(e) {
      //不允许停靠
      if ((e.draggedContext.futureIndex == 0 || e.draggedContext.futureIndex == 1 || e.draggedContext.futureIndex == 2) && this.$route.params.type == 'DETAILS' && this.arr2[0].style.isDisplayNavigation) return false;
      if ((e.draggedContext.futureIndex == 0 || e.draggedContext.futureIndex == 1) && this.$route.params.type == 'DETAILS' && !this.arr2[0].style.isDisplayNavigation) return false;
      return !(e.draggedContext.futureIndex == 0 && this.$route.params.type != 'DETAILS');
    },
    onScroll(e) {
      let scrollItems = document.querySelectorAll('.navItemBox');
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop;
        if (judge) {
          this.activeStep = i;
          break;
        }
      }
    },
    navChange(val) {
      this.navIndex = val;
      let items = document.querySelectorAll('.navItemBox');
      this.$nextTick(() => {
        for (let i = 0; i < items.length; i++) {
          if (val === i) {
            items[i].scrollIntoView({
              block: 'start',
              //默认跳转到顶部
              behavior: 'smooth' //滚动的速度
            });
          }
        }
      });
    },
    itemFun(val, valIndex) {
      this.itemIndex = valIndex;
      this.changeType = !this.changeType;
      this.arr2.map((item, index) => {
        if (index != valIndex) {
          item.isClick = false;
        } else {
          item.isClick = true;
        }
      });
      this.configureList = [];
      this.navList.map(item => {
        if (item.mark == val.controlsMark) {
          this.configureList = item.childer;
        }
      });
      this.configureObj = val;
    },
    /**
     * 不使用itemChange是因为恢复默认设置的时候需要初始化标题
     * pageTitleChange 配置区页面标题重置
     */
    pageTitleChange(val) {
      this.arr2[0].style.pageTitle = val;
    },
    // 配置区域改变
    itemChange(val, showPage) {
      console.log(val, '--------itemChange--------');
      console.log(this.arr2, '--------itemChange this.arr2--------');
      console.log(this.itemIndex, '--------itemChange this.itemIndex--------');
      let obj = recursionCopy(this.arr2[this.itemIndex]);
      console.log(obj, '--------itemChange obj--------');
      if (obj.style) {
        obj.style = val;
      }
      // 删除之前选中的并添加更改后的
      this.arr2.splice(this.itemIndex, 1, obj);
      this.configureObj = recursionCopy(this.arr2[this.itemIndex]);
      if (this.configureObj.controlsMark == 'titleTop') {
        console.log(this.arr2, this.pageTypeName, '--------change arr2----------');
        if (val.isDisplayNavigation && this.$route.params.type == 'DETAILS') {
          let NAVUGATIOBNOBJ = recursionCopy(this.NAVUGATIOBN);
          const obj = this.navList.find(item2 => item2.mark == 'navigation');
          NAVUGATIOBNOBJ.controlsId = obj.id;
          NAVUGATIOBNOBJ.style.controlsComponentsId = obj.childer[0].id;
          NAVUGATIOBNOBJ.style.controlsComponentsMark = obj.childer[0].mark;
          console.log(obj, NAVUGATIOBNOBJ, 222);
          if (this.arr2[1].controlsMark != 'navigation') {
            this.arr2.splice(1, 0, NAVUGATIOBNOBJ);
          }
        } else {
          var _this$arr2$;
          if (((_this$arr2$ = this.arr2[1]) === null || _this$arr2$ === void 0 ? void 0 : _this$arr2$.controlsMark) == 'navigation') {
            this.arr2.splice(1, 1);
          }
        }
        this.arr2.map(item => {
          if (item.controlsMark == 'navigation') {
            item.style.fontColor = val.themeColor;
          }
        });
        console.log(val, '--------配置区域改变val--------');
        // 页面说明
        this.pageContentAssignment(val, showPage);
        this.isDisplayNavigation = val.isDisplayNavigation;
        this.themeColor = val.themeColor;
      } else if (this.configureObj.controlsMark == 'bottomButton') {
        this.arr2.map(item => {
          if (item.controlsMark == 'product' || item.controlsMark == 'information') {
            item.style.clauseColor = val.buttonInfo[0].buttonBgColor;
          } else if (item.controlsMark == 'trial') {
            item.style.color = val.buttonInfo[0].buttonBgColor;
          }
        });
      }
      this.arr2.map(item => {
        if (item.controlsMark == 'product' || item.controlsMark == 'information') {
          item.style.clauseColor = this.themeColor;
        }
      });
      if (this.buttonModalIndex > -1) {
        this.onOpenButtonModal(this.buttonModalIndex, 'change');
      }
    },
    itemDelFun(index) {
      console.log(index, '--------itemDelFun--------');
      console.log(this.arr2, '--------itemDelFun this.arr2--------');
      console.log(this.itemIndex, '--------itemDelFun this.itemIndex--------');
      this.itemIndex = 0;
      console.log(this.itemIndex, '--------itemDelFun this.itemIndex 新值--------');
      this.arr2.splice(index, 1);
      this.arr2[0].isClick = true;
      this.configureObj = this.arr2[0];
    },
    upItemFun(index) {
      console.log(index, index - 1);
      this.arr2 = this.swapItems(this.arr2, index, index - 1);
      this.itemFun(this.arr2[index - 1], index - 1);
    },
    itemDownFun(index) {
      this.arr2 = this.swapItems(this.arr2, index, index + 1);
      this.itemFun(this.arr2[index + 1], index + 1);
    },
    swapItems(arr, index1, index2) {
      //交换元素 --//数组,元素1，元素2
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    async saveFun() {
      var _arr$find;
      if (this.$route.params.type != 'DETAILS' && this.$route.params.type != 'LANDING_PAGE' && this.$route.params.type != 'INFORECORD_PAGE' && this.$route.params.type != 'PRODUCT_LIST_PAGE' && this.$route.params.type != 'QUERY_INFO_PAGE' && this.$route.params.type != 'INVOICE_RECORD_LIST_PAGE') {
        console.log(this.arr2.length - 1, this.arr2);
        if (this.arr2.length < 3) {
          this.$message.destroy();
          return this.$message.error(this.$t('控件数量最少选择两个'));
        }
      } else if (this.$route.params.type == 'PRODUCT_LIST_PAGE' || this.$route.params.type == 'QUERY_INFO_PAGE' || this.$route.params.type == 'INVOICE_RECORD_LIST_PAGE') {
        let num = this.arr2.length - 1;
        if (num < 1) {
          this.$message.destroy();
          return this.$message.error(this.$t('控件数量最少选择一个'));
        }

        // 判断sessionStorage中是否有oldFrom
        if (sessionStorage.getItem('oldForm')) {
          sessionStorage.removeItem('oldForm');
        }
        if (this.$route.params.type == 'PRODUCT_LIST_PAGE') {
          // 判断落地页的背景图
          let isBg = true;
          let isName = true;
          let isBtnevent = true;
          this.arr2.findIndex(i => {
            if (i.controlsMark == 'productList' && i.style.landingPageModuleDisplay) {
              var _i$style$landingPageM;
              if (!i.style.landingPageModule.backgroundImage) {
                this.$message.error(this.$t('请上传落地页背景图'));
                isBg = false;
              }
              (_i$style$landingPageM = i.style.landingPageModule) === null || _i$style$landingPageM === void 0 || (_i$style$landingPageM = _i$style$landingPageM.buttonInfo) === null || _i$style$landingPageM === void 0 || _i$style$landingPageM.map(item => {
                if (!item.buttonName || item.buttonName.length < 2 || item.buttonName.length > 15) {
                  if (item.buttonName == '') {
                    this.$message.error(this.$t('请填写按钮文案'));
                  } else if (item.buttonName.length < 2 || item.buttonName.length > 15) {
                    this.$message.error(`${this.$t('请输入')}2-15${this.$t('字符')}`);
                  }
                  isName = false;
                } else if (!item.buttonJumpEvent) {
                  this.$message.error(this.$t('请选择') + this.$t('按钮跳转模版'));
                  isBtnevent = false;
                }
              });
            }
          });
          if (!isBg || !isName || !isBtnevent) {
            return;
          }
        }
      } else if (this.$route.params.type == 'LANDING_PAGE' || this.$route.params.type == 'INFORECORD_PAGE') {
        let num = this.arr2.length - 1;
        if (num < 1 || num > 6) {
          this.$message.destroy();
          return this.$message.error(this.$t('控件数量最少选择一个,最多选择六个'));
        }
      } else {
        let num = this.arr2.length - 3;
        if (!this.arr2[0].style.isDisplayNavigation) {
          num = this.arr2.length - 2;
        }
        if (num < 2 || num > 6) {
          this.$message.destroy();
          return this.$message.error(this.$t('控件数量最少选择两个,最多选择六个'));
        }
      }
      const arr = recursionCopy(this.arr2);
      // 页面标题不能为空
      let isPageTitle = true;
      if (this.$route.params.type != 'DETAILS' && arr[0].style.pageTitle == '') {
        this.$message.destroy();
        this.$message.error(this.$t('请输入') + this.$t('页面标题'));
        isPageTitle = false;
      }
      if (!isPageTitle) {
        return;
      }
      // 详情页主图后缀判断
      if (this.$route.params.type == 'DETAILS') {
        let res = this.arr2.findIndex(i => i.controlsMark == 'mainDrawing');
        if (res > -1) {
          if (this.arr2[res].style.controlsComponentsMark == 'mainDrawing7' || this.arr2[res].style.controlsComponentsMark == 'mainDrawing6') {
            var _this$arr2$res$style$, _this$arr2$res$style$2;
            if (!this.arr2[res].style.thirdCompanySuffix) {
              this.$message.destroy();
              return this.$message.error(this.$t('请输入') + this.$t('后缀信息'));
            } else if (this.arr2[res].style.thirdCompanySuffix && !this.arr2[res].style.thirdCompanySuffix.length) {
              this.$message.destroy();
              return this.$message.error(this.$t('请输入') + this.$t('后缀信息'));
            } else if (this.arr2[res].style.thirdCompanySuffix && ((_this$arr2$res$style$ = this.arr2[res].style.thirdCompanySuffix) === null || _this$arr2$res$style$ === void 0 ? void 0 : _this$arr2$res$style$.length) > 20 || ((_this$arr2$res$style$2 = this.arr2[res].style.thirdCompanySuffix) === null || _this$arr2$res$style$2 === void 0 ? void 0 : _this$arr2$res$style$2.length) < 2) {
              this.$message.destroy();
              return this.$message.error(this.$t('后缀信息') + this.$t('请输入') + '2-20' + this.$t('字符'));
            }
          }
        }
      }
      const find = this.repeatyArr(arr);
      if (find) {
        this.$message.destroy();
        return this.$message.error(this.$t(this.CONFIGURENAME[find.controlsMark]) + this.$t('组件重复,只能存在一个'));
      }
      // 保单详情增加非可退保文案、开具发票页上限数量提示
      let isLimit = true;
      this.arr2.findIndex(i => {
        if (i.controlsMark == 'invoiceList') {
          if (i.style.invoiceConfig.maxSelect === '') {
            this.$message.destroy();
            isLimit = false;
            return this.$message.error(this.$t('请输入保单批量勾选上限数量'));
          } else if (i.style.invoiceConfig.maxSelect < 1 || i.style.invoiceConfig.maxSelect > 50) {
            this.$message.destroy();
            isLimit = false;
            return this.$message.error(this.$t('请输入') + '1-50' + this.$t('之间的数字'));
          } else {
            isLimit = true;
          }
        } else if (i.controlsMark === 'policyDetail') {
          if (i.style.policyCancelConfig.uncancelableTips === '') {
            this.$message.destroy();
            isLimit = false;
            return this.$message.error(this.$t('非可退保单提示文案非有效输入，请重新输入'));
          } else {
            isLimit = true;
          }
        }
      });
      if (!isLimit) {
        return;
      }
      if (!arr[0].style.isDisplayNavigation) {
        let res = arr.findIndex(i => i.controlsMark == 'navigation');
        if (res > -1) {
          this.$message.destroy();
          return this.$message.error(this.$t('导航栏为固定模块，不可添加'));
        }
      }
      const lookUpInformation = arr.filter(item => item.controlsMark == 'information');
      if (lookUpInformation.length != 0) {
        console.log(lookUpInformation[0], 222444);
        if (lookUpInformation[0].style.limit == 3 && !lookUpInformation[0].style.time && !lookUpInformation[0].style.isHiddenClause) {
          this.$message.destroy();
          return this.$message.error(this.$t('投保信息组件需要填写阅读时间'));
        } else if (lookUpInformation[0].style.limit == 3 && lookUpInformation[0].style.time && !lookUpInformation[0].style.isHiddenClause) {
          if (lookUpInformation[0].style.time < 1) {
            this.$message.destroy();
            return this.$message.error(this.$t('投保信息组件阅读时间至少一秒'));
          }
        }
      }
      // 产品列表不需要判断底部按钮、开票记录页不需要判断底部按钮
      if (this.$route.params.type != 'PRODUCT_LIST_PAGE' && this.$route.params.type != 'INVOICE_RECORD_LIST_PAGE') {
        const lookUpBtn = arr.filter(item => item.controlsMark == 'bottomButton');
        // 查询记录页底部按钮非必选
        if (lookUpBtn.length == 0 && this.$route.params.type != 'QUERY_INFO_PAGE') {
          this.$message.destroy();
          return this.$message.error(this.$t('至少添加一个底部按钮组件'));
        } else {
          let adopt = true;
          lookUpBtn.map(item => {
            item.style.buttonInfo.map(item2 => {
              if (!item2.buttonName) {
                adopt = false;
              }
            });
          });
          if (!adopt) {
            this.$message.destroy();
            return this.$message.error(this.$t('需要完善按钮控件里的按钮文案'));
          }
        }
        // 如果是查询记录页且arr包含底部按钮，最后一个组件必须是底部按钮
        if (this.$route.params.type == 'QUERY_INFO_PAGE' && lookUpBtn.length != 0 && arr[arr.length - 1].controlsMark != 'bottomButton') {
          this.$message.destroy();
          return this.$message.error(this.$t('最后一个组件必须是底部按钮'));
        }
        //
        if (this.$route.params.type != 'QUERY_INFO_PAGE' && arr[arr.length - 1].controlsMark != 'bottomButton') {
          this.$message.destroy();
          return this.$message.error(this.$t('最后一个组件必须是底部按钮'));
        }
      }

      // 页面说明
      if (this.pageDescription) {
        let res = !this.pageDescriptionConfig.content || this.pageDescriptionConfig.content.length < 2 || this.pageDescriptionConfig.content.length > 40;
        if (res) {
          this.$message.destroy();
          return this.$message.error(this.$t('页面说明内容') + this.$t('请输入') + '2-40' + this.$t('字符'));
        }
      }

      // 页面弹窗
      if (this.pagePopUp) {
        let res1 = !this.pagePopUpConfig.buttonName || this.pagePopUpConfig.buttonName.length < 1 || this.pagePopUpConfig.buttonName.length > 15;
        if (res1) {
          this.$message.destroy();
          return this.$message.error(this.$t('页面弹窗按钮文案') + this.$t('请输入') + '1-15' + this.$t('字符'));
        }
        if (this.$route.params.type != 'DETAILS') {
          let res2 = this.pagePopUpConfig.popUpTitle && (this.pagePopUpConfig.popUpTitle.length < 2 || this.pagePopUpConfig.popUpTitle.length > 15);
          if (res2) {
            this.$message.destroy();
            return this.$message.error(this.$t('页面弹窗标题') + this.$t('请输入') + '2-15' + this.$t('字符'));
          }
          let res3 = !this.pagePopUpConfig.popUpContent || this.pagePopUpConfig.popUpContent.length < 5 || this.pagePopUpConfig.popUpContent.length > 100;
          if (res3) {
            this.$message.destroy();
            return this.$message.error(this.$t('页面弹窗内容') + this.$t('请输入') + '5-100' + this.$t('字符'));
          }
        }
      }
      // 按钮弹窗
      let btnRes = (_arr$find = arr.find(i => i.controlsMark == 'bottomButton')) === null || _arr$find === void 0 || (_arr$find = _arr$find.style) === null || _arr$find === void 0 ? void 0 : _arr$find.buttonInfo;
      console.log(btnRes, 222211);
      // 查询记录页选择了底部按钮需要判断底部文案
      if (btnRes) {
        let isBtnTrue = true;
        btnRes.map((item, i0) => {
          if (item.buttonPopUp && isBtnTrue) {
            let config = item.buttonPopUpConfig;
            if (config.popUpTitle && (config.popUpTitle.length < 2 || config.popUpTitle.length > 15)) {
              isBtnTrue = false;
              this.$message.destroy();
              return this.$message.error(`${this.$t('按钮设置')}${i0 + 1}：${this.$t('弹窗提示标题')}${this.$t('请输入')}2-15${this.$t('字符')}`);
            }
            if (!config.popUpContent || config.popUpContent.length < 5 || config.popUpContent.length > 200) {
              isBtnTrue = false;
              this.$message.destroy();
              return this.$message.error(`${this.$t('按钮设置')}${i0 + 1}：${this.$t('弹窗内容')}${this.$t('请输入')}5-200${this.$t('字符')}`);
            }
            config.buttonInfo.map((i, i1) => {
              if (!i.buttonName || i.buttonName.length < 1 || i.buttonName.length > 15 && isBtnTrue) {
                isBtnTrue = false;
                return this.$message.error(`${this.$t('按钮设置')}${i0 + 1}-${this.$t('弹窗按钮')}${i1 + 1}：${this.$t('按钮文案')}${this.$t('请输入')}1-15${this.$t('字符')}`);
              }
              if (!i.buttonEvent && isBtnTrue) {
                isBtnTrue = false;
                this.$message.destroy();
                return this.$message.error(`${this.$t('按钮设置')}${i0 + 1}-${this.$t('弹窗按钮')}${i1 + 1}：${this.$t('请选择')}${this.$t('弹窗按钮事件')}`);
              }
            });
            let jumps = config.buttonInfo.filter(i => i.buttonEvent == 'jump');
            if (jumps.length != 1 && isBtnTrue) {
              isBtnTrue = false;
              this.$message.destroy();
              return this.$message.error(`${this.$t('按钮设置')}${i0 + 1}-${this.$t('弹窗按钮')}${this.$t('必须有一个跳转事件')}`);
            }
          }
        });
        if (!isBtnTrue) {
          return;
        }
      }

      //数组组合
      let controlsConfig = [];
      arr.map((item, index) => {
        if (index != 0) {
          let obj = {
            controlsId: item.controlsId,
            controlsMark: item.controlsMark,
            controlsJump: undefined,
            controlsComponentsId: item.style.controlsComponentsId,
            controlsComponentsMark: item.style.controlsComponentsMark,
            controlsObject: item.style
          };
          if (item.controlsMark == 'bottomButton') {
            console.log(item.style, 222211);
          }
          controlsConfig.push(obj);
        }
      });
      let parameter = arr[0].style;
      parameter.controlsConfig = controlsConfig;
      await dynamicControlSetConfig({
        id: this.$route.params.id,
        controlsGroupConfig: JSON.stringify(parameter)
      });
      this.$message.destroy();
      this.$message.success(this.$t('操作成功'));
      this.$router.go(-1);
    },
    repeatyArr(arr) {
      let find = false;
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].controlsMark == arr[j].controlsMark) {
            find = arr[j];
            break;
          }
        }
        if (find) break;
      }
      return find;
    }
  }
};